import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

import Nav from "./components/Nav";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Quote from "./pages/Quote";
import Contact from "./pages/Contact";

import Terms from "./pages/Terms";
import RefundPolicy from "./pages/RefundPolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import FAQs from "./pages/FAQs";
import DeliveryPolicy from "./pages/DeliveryPolicy";
import JobTracking from "./pages/JobTracking";
import PaymentSuccess from "./pages/PaymentSuccess";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <>
      <ScrollToTop />

      <Nav />

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/quote" element={<Quote />} />
          <Route path="/contact" element={<Contact />} />

          <Route path="/terms" element={<Terms />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/delivery-policy" element={<DeliveryPolicy />} />
          <Route path="/job/:jobId" element={<JobTracking />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
        </Routes>
      </main>

      <Footer />
    </>
  );
}